import { LockSolidIcon } from '@tableau/icons/LockSolidIcon';
import { Colors } from '@tableau/icons/util/Colors';
import { TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { cssClass } from '../../../../common/styles/CommonStyles';
import { generateUniqueId } from '../../../../common/utils/DomUtils';

export const CollectionsPrivateIndicatorIdPrefix = 'collections-private-indicator';

const PrivateCollectionAreaListView = cssClass('collections-private-indicator', {
  paddingLeft: TabStyles.Spacing.DefaultSpace,
  fontSize: '12px',
  fontWeight: 'normal',
});

export const CollectionPrivateHeader = 'collection-private-header';

export function CollectionsPrivateIndicator() {
  const privateIndicatorId = generateUniqueId(CollectionsPrivateIndicatorIdPrefix);
  return (
    <span className={PrivateCollectionAreaListView} id={privateIndicatorId}>
      <div data-tb-test-id={CollectionPrivateHeader}>
        <LockSolidIcon size={14} color={Colors.Default} />
        <span style={{ marginLeft: 2 }}>{Messages.collectionVisibilityPrivateCellLabel()}</span>
      </div>
    </span>
  );
}
